import { determineAppEnvironment, determineConfigEnvironment } from '../config/utils';

export const appEnvironment = determineAppEnvironment();
export const configEnvironment = determineConfigEnvironment(appEnvironment);
